<template>
  <div class="c-config-content">
    <div class="row">
      <div class="col-md-3">
        <form-checkbox :model="model" attribute="recordInbound" :chk-label="$t('recordInbound')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :model="model" attribute="recordOutbound" :chk-label="$t('recordOutbound')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :model="model" attribute="recordLocal" :chk-label="$t('recordLocal')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :model="model" attribute="callConnectPromptSounds" :chk-label="$t('callConnectPromptSounds')"></form-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button @click="save" class="btn btn-primary">{{$t('save')}}</button>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {},
      errors: {}
    }
  },
  methods: {
    load() {
      this.$service.get('/client/setting').then(response => {
        this.model = {};
        this.model = response.data;
      }).finally(() => {
      });
    },
    save() {
      this.$service.put('/client/setting', this.model).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updated'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
        } else {
          this.errors = error.response.data;
        }
      });
    }
  },
  mounted() {
    this.load();
  }
}
</script>